<template>
  <div :class="vertical ? 'flex flex-col gap-3' : 'flex gap-4 items-center'">
    <!-- Ortak linkler -->
    <NuxtLink
      to="/"
      class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base hover:rounded-full hover:bg-black hover:opacity-80"
    >
      {{ t("nav.home") }}
    </NuxtLink>

    <NuxtLink
      to="/block"
      class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base hover:rounded-full hover:bg-black hover:opacity-80"
    >
      {{ t("nav.course") }}
    </NuxtLink>

    <NuxtLink
      to="/daily-blog"
      class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base hover:rounded-full hover:bg-black hover:opacity-80"
    >
      {{ t("nav.blog") }}
    </NuxtLink>

    <NuxtLink
      to="/kariyer"
      class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base hover:rounded-full hover:bg-black hover:opacity-80"
    >
      {{ t("nav.career") }}
    </NuxtLink>

    <NuxtLink
      to="/contact"
      class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base hover:rounded-full hover:bg-black hover:opacity-80"
    >
      {{ t("nav.contact") }}
    </NuxtLink>

    <!-- Giriş yaptıysa -->
    <template v-if="user">
      <div class="flex items-center gap-3">
        <NuxtLink
          to="/dashboard"
          class="bg-teal-500 text-white w-12 h-12 rounded-full flex items-center justify-center font-semibold text-lg"
        >
          {{ getInitials(user.user_metadata?.name || user.email) }}
        </NuxtLink>

        <button
          class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base rounded-full bg-[#3DCBB1] border border-[#3DCBB1] hover:opacity-80 flex items-center gap-2"
          @click="logout"
        >
          <img
            src="assets/images/timelapse_24px.png"
            alt="timelaps"
            class="w-5 h-5"
          />
          {{ t("nav.logout") }}
        </button>
      </div>
    </template>

    <!-- Giriş yapılmadıysa -->
    <template v-else>
      <a
        href="#"
        class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base rounded-full border border-[#262626] hover:opacity-80"
        @click="$emit('login-click')"
      >
        {{ t("nav.login") }}
      </a>

      <a
        href="#"
        class="px-4 md:px-4 lg:px-5 xl:px-3 2xl:px-5 py-2 text-sm md:text-base rounded-full bg-[#3DCBB1] border border-[#3DCBB1] hover:opacity-80 flex items-center gap-2"
        @click="$emit('signup-click')"
      >
        <img
          src="assets/images/timelapse_24px.png"
          alt="timelaps"
          class="w-5 h-5"
        />
        {{ t("nav.signup") }}
      </a>
    </template>
  </div>
</template>

<script setup lang="ts">
import { useSupabaseUser, useSupabaseClient, useI18n } from "#imports";
const { t } = useI18n();
const router = useRouter();
const user = useSupabaseUser();
const supabase = useSupabaseClient();

const logout = async () => {
  await supabase.auth.signOut();

  router.push("/");
};

const getInitials = (name: string | undefined) => {
  if (!name) return "U";
  const parts = name.split(" ");
  return parts
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();
};

defineProps({
  vertical: {
    type: Boolean,
    default: false,
  },
});
</script>
